import { TileNode } from '@/components/diagrams/FlowChart/types';
import { EntityKind } from '@/types/schema';

type TileNodeTypename =
  | 'Entity'
  | 'TestamentaryEntity'
  | 'ClientProfile'
  | 'ClientOrganization';

export interface TileEntityMetadata {
  entityKind: EntityKind | null;
  nodeTypename: TileNodeTypename | null;
  displayName: string | null;
}

/**
 * Reads routing metadata stashed on a diagram tile's data by
 * `buildTileFromNode`. Returns null fields when the source tile was not
 * built via the entity-diagram pipeline. Only the node's `data` is read, so
 * callers that hold just that (e.g. a React Flow node's props) can pass
 * `{ data }` without conjuring a full node.
 */
export function getTileEntityMetadata(
  node: Pick<TileNode, 'data'> | null
): TileEntityMetadata {
  const data = node?.data as Record<string, unknown> | undefined;
  const entityKind = data?.tileEntityKind;
  const nodeTypename = data?.tileNodeTypename;
  const displayName = data?.tileDisplayName;
  return {
    entityKind:
      typeof entityKind === 'string' ? (entityKind as EntityKind) : null,
    nodeTypename:
      typeof nodeTypename === 'string'
        ? (nodeTypename as TileNodeTypename)
        : null,
    displayName: typeof displayName === 'string' ? displayName : null,
  };
}
